import * as users from "./users";
import * as leads from "./leads";
import * as general from "./general";
import * as sms from "./sms";
import * as emails from "./emails";
/**
 * Creates an instance of
 * axios that always uses the eatup api
 * base route
 */
export const api = {
  users,
  leads,
  general,
  sms,
  emails
};

// export const setAuthToken = token => {
//   if (token) {
//     // Apply authorization token to every request if logged in
//     http.defaults.headers.common["Authorization"] = "Bearer " + token;
//     http.defaults.headers.post["Content-Type"] = "application/json";
//   } else {
//     // Delete auth header
//     delete http.defaults.headers.common["Authorization"];
//   }
// };
